(() => {
  const MOBILE_BP = 767.98;

  function initAll(scope = document) {
    const wrappers = scope.querySelectorAll('.main-product__media-wrapper');
    wrappers.forEach(initGallery);
  }

  function initGallery(wrapper) {
    if (wrapper.dataset.mobileThumbsReady === 'true') return;
    wrapper.dataset.mobileThumbsReady = 'true';

    const mainEl = wrapper.querySelector('swiper-container[id^="gallery-main-product-"]');
    const mobileThumbs = wrapper.querySelector('[data-product-mobile-thumbs]');
    const desktopThumbs = Array.from(wrapper.querySelectorAll('.swiper-thumbnails swiper-slide'));

    if (!mainEl) return;

    const waitForSwiper = () => {
      if (!mainEl.swiper) {
        requestAnimationFrame(waitForSwiper);
        return;
      }

      setupGallery(wrapper, mainEl, mobileThumbs, desktopThumbs);
    };

    waitForSwiper();
  }

  function setupGallery(wrapper, mainEl, mobileThumbs, desktopThumbs) {
    const mainSwiper = mainEl.swiper;
    if (!mainSwiper) return;

    const mobileThumbButtons = mobileThumbs
      ? Array.from(mobileThumbs.querySelectorAll('.product-mobile-thumb'))
      : [];

    function isMobile() {
      return window.innerWidth <= MOBILE_BP;
    }

    function getIndex() {
      return typeof mainSwiper.realIndex === 'number'
        ? mainSwiper.realIndex
        : (mainSwiper.activeIndex || 0);
    }

    function centerThumbInStrip(container, thumb) {
      if (!container || !thumb) return;

      const containerRect = container.getBoundingClientRect();
      const thumbRect = thumb.getBoundingClientRect();

      const currentScroll = container.scrollLeft;
      const thumbLeftInContainer = thumbRect.left - containerRect.left + currentScroll;
      const targetScroll =
        thumbLeftInContainer - (container.clientWidth / 2) + (thumb.clientWidth / 2);

      container.scrollTo({
        left: Math.max(0, targetScroll),
        behavior: 'smooth'
      });
    }

    function goToSlide(index) {
      if (typeof mainSwiper.slideToLoop === 'function' && mainSwiper.params.loop) {
        mainSwiper.slideToLoop(index);
      } else {
        mainSwiper.slideTo(index);
      }
    }

    function updateActiveThumbs() {
      const index = getIndex();

      mobileThumbButtons.forEach((thumb, i) => {
        thumb.classList.toggle('is-active-thumb', i === index);
      });

      desktopThumbs.forEach((thumb, i) => {
        thumb.classList.toggle('is-active-thumb', i === index);
      });

      if (isMobile() && mobileThumbs) {
        const activeMobileThumb = mobileThumbButtons[index];
        if (activeMobileThumb) {
          centerThumbInStrip(mobileThumbs, activeMobileThumb);
        }
      }
    }

    function applyResponsiveState() {
      if (isMobile()) {
        wrapper.classList.add('mobile-thumbs-ready');

        mainSwiper.params.slidesPerView = 1;
        mainSwiper.params.spaceBetween = 0;
        mainSwiper.params.centeredSlides = false;
        mainSwiper.params.freeMode = false;
        mainSwiper.allowTouchMove = true;
        mainSwiper.update();
      } else {
        wrapper.classList.remove('mobile-thumbs-ready');

        mainSwiper.params.slidesPerView = 1;
        mainSwiper.params.spaceBetween = 0;
        mainSwiper.params.centeredSlides = false;
        mainSwiper.params.freeMode = false;
        mainSwiper.allowTouchMove = true;
        mainSwiper.update();
      }

      updateActiveThumbs();
    }

    mobileThumbButtons.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const index = Number(thumb.dataset.thumbIndex || 0);
        goToSlide(index);
      });
    });

    desktopThumbs.forEach((thumb, index) => {
      thumb.style.cursor = 'pointer';
      thumb.addEventListener('click', () => {
        goToSlide(index);
      });
    });

    mainSwiper.on('slideChange', updateActiveThumbs);
    mainSwiper.on('transitionEnd', updateActiveThumbs);

    applyResponsiveState();
    window.addEventListener('resize', applyResponsiveState);
  }

  document.addEventListener('DOMContentLoaded', () => initAll(document));
  window.addEventListener('load', () => initAll(document));
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();